// extracted by mini-css-extract-plugin
module.exports = {"table":"table__b7O6n","row":"row__lA6ws","head":"head__r1Osx","nameCell":"nameCell__IxdSy","iconCell":"iconCell__EEByM","activityCell":"activityCell__IB384"};